import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=56231a5e&scoped=true"
import script from "./AlertHistory.vue?vue&type=script&lang=js"
export * from "./AlertHistory.vue?vue&type=script&lang=js"
import style0 from "./AlertHistory.vue?vue&type=style&index=0&id=56231a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56231a5e",
  null
  
)

export default component.exports